var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 62627",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.023,
    height: 33.237,
    viewBox: "0 0 33.023 33.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "v9c2cnkoga",
    cx: 0.227,
    cy: 0.259,
    r: 0.841,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606,
    stopColor: "#ff9d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8000"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13068"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13067"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9225",
    d: "M3009.424 4523.118a16.512 16.512 0 1 1-16.512-16.618 16.577 16.577 0 0 1 16.512 16.618z",
    transform: "translate(-2976.4 -4506.5)",
    style: {
      fill: "url(#v9c2cnkoga)"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13071"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13069",
    transform: "translate(20.025 11.032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 170",
    cx: 2.178,
    cy: 2.192,
    rx: 2.178,
    ry: 2.192
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13070",
    transform: "translate(8.783 11.032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 171",
    cx: 2.178,
    cy: 2.192,
    rx: 2.178,
    ry: 2.192
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13072"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9226",
    d: "M8.712 23.973a25.532 25.532 0 0 1 3.935-.707 36.637 36.637 0 0 1 7.87 0 25.505 25.505 0 0 1 3.934.707c.071 0 .071.071.071.142a.07.07 0 0 1-.071.071 25.554 25.554 0 0 1-3.934.707 36.553 36.553 0 0 1-7.87 0 25.591 25.591 0 0 1-3.935-.707.134.134 0 0 1 0-.212z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.023bd0fb240f80e059a6cf87923ba2d6.svg";
export { ForwardRef as ReactComponent };